import { GridPaginationModel } from "@mui/x-data-grid";
import { AxiosError } from "axios";
import { action, makeObservable, observable } from "mobx";
import { Subscription, delay, finalize, of } from "rxjs";
import { IPageRequest, IPagedResult } from "src/Shared/Interfaces";
import { ToastService } from "src/Shared/Services";
import { IRootStore } from "src/Shared/Stores/Root.store";
import { ISlaReporting } from "../Interfaces/ISlaReporting";
import CompanyService from "../Services/Company.service";
import { ICompaniesSLAFilterRequest } from "../Interfaces/ICompaniesSLAFilterRequest";
import DateTimeUtils from "src/Shared/Tools/DateTimeUtils";

export class SlaReportingStore {
  rootStore: IRootStore;
  public gridLoading: boolean = false;

  public slaReprotingList: IPagedResult<ISlaReporting> = {
    pageNumber: 0,
    pageSize: 25,
    results: [],
    totalNumberOfRecords: 0,
  };

  public slaReporting: ISlaReporting | null = null;
  public overViewLoading: boolean = false;
  public pagination: GridPaginationModel = { page: 0, pageSize: 25 };

  constructor(rootStore: IRootStore) {
    makeObservable(this, {
      gridLoading: observable,
      slaReprotingList: observable,
      setGridLoading: action,
      getSlaReporting: action.bound,
      setSlaReportingList: action,
      pagination: observable,
      setPagination: action,
    });
    this.rootStore = rootStore;
  }

  setGridLoading = (flag: boolean): void => {
    this.gridLoading = flag;
  };

  getSlaReporting(
    request: IPageRequest<ICompaniesSLAFilterRequest>,
  ): Subscription {
    this.setGridLoading(true);
    return CompanyService.slaReporting(request)
      .pipe(
        finalize(() => {
          this.setGridLoading(false);
        }),
      )
      .subscribe({
        next: (data) => {
          this.setSlaReportingList(data);
        },
        error: (error: AxiosError) => ToastService.axiosError(error),
      });
  }

  setSlaReportingList(data: IPagedResult<ISlaReporting>) {
    if (data) {
      data.results = data.results.map((x) => {
        x.slaExpiryDateFormated = x.slaExpiryDate ? DateTimeUtils.dateToLocalDateZone(x.slaExpiryDate) : "-";
        return x;
      });
      this.slaReprotingList = data;
    }
  }

  resetSlaReportingList = () => {
    const slaReprotingList = { ...this.slaReprotingList };
    slaReprotingList.results = [];
    this.setSlaReportingList(slaReprotingList);
  };

  setPagination = (data: GridPaginationModel) => {
    this.pagination = { ...data };
  };
}
